import React from "react";
// Components
import VerifySession from "../../../config/verifySession";
import AdminValidation from "../../../config/adminValidation";
import EditProtocolComponent from "../../../components/protocolsManagement/sections/editProtocol";

const EditProtocolView = () => (
  <>
    {VerifySession()}
    {AdminValidation()}
    <EditProtocolComponent />
  </>
);

export default EditProtocolView;
